import FlashLib from "flashlib";
import EntryPoint from "Engine/EntryPoint";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";

export default class BaseAutoPlayStopSettingsContainer extends FlashLib.MovieClip {
    constructor(data, displayData) {
        super(data, displayData);

        this.toggles = [];

        this.init();
    }

    init() {
        for(let i = 1; i <= 4; i++) {
            let toggle = this.getChildByName('toggle_' + i);
            toggle.enabled = true;
            toggle.actions = {
                checked: {
                    callback: this.onCountChecked, context: this, params: toggle
                }
            };
            this.toggles.push(toggle);
        }
    }

    onCountChecked(data) {
        //this.setChecked();
    }

    setChecked() {
        this.toggles.forEach((checkBox, index)=> {
            checkBox.checked = checkBox.value === this.selected;
            checkBox.enabled = !checkBox.checked;
        });
    }
}